import React from "react";
import {AiFillInfoCircle} from 'react-icons/ai';

let InformationLabel = ({text}) => <label className='information-text'>
    <AiFillInfoCircle/>
    {text}
</label>

export default InformationLabel